import { Button, Card, Col, Input, message, Row, Select } from 'antd';
import { ErrorMessage, Form, Formik } from 'formik';
import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import Item from '../../components/Form/Item';
import { ADMIN_PROJECT, initialValues, SUPERADMIN, userSchema } from './schema';
import axios from '../../util/Api';
import Auxiliary from '../../util/Auxiliary';
import Title from '../../components/Title/Title';
import ProjectSelect from './ProjectSelect';

const Create = (props) => {
  const history = useHistory();
  return (
    <Auxiliary>
      <Title>Buat User Baru</Title>
      <Row>
        <Col span={16}>
          <Formik
            initialValues={initialValues}
            validationSchema={userSchema}
            onSubmit={values => {
              const url = `/user/create`;
              axios.post(url, { ...values }).then(resp => {
                message.success(`User ${resp.data.user.name} telah berhasil dibuat`);
                // history.push(`/`);
                history.push(`/users/detail?id=${resp.data.user.id}`);
              }).catch(err => {
                message.error('Gagal membuat user');
              });
            }}
          >
            {formik => (
              <Form>
                <Card className="gx-card">
                  <Item name="Nama User" required>
                    <Input name="name" onChange={formik.handleChange} />
                    <ErrorMessage component="div" name="name" className="gx-text-danger gx-text-sm" />
                  </Item>
                  <Item name="Email" required>
                    <Input name="email" onChange={formik.handleChange} />
                    <ErrorMessage component="div" name="email" className="gx-text-danger gx-text-sm" />
                  </Item>
                  {/* <Item name="Password" required>
                    <Input type="password" name="password" onChange={formik.handleChange} />
                    <ErrorMessage component="div" name="password" className="gx-text-danger gx-text-sm" />
                  </Item>
                  <Item name="Konfirmasi Password" required>
                    <Input type="password" name="confirm_password" onChange={formik.handleChange} />
                    <ErrorMessage component="div" name="confirm_password" className="gx-text-danger gx-text-sm" />
                  </Item> */}
                  <hr />
                  <Item name="Jenis User" required>
                    <Select
                      name="role"
                      onChange={(val) => formik.setFieldValue("role", val)}
                      defaultValue={formik.values.role}
                      style={{ width: 320 }}
                    >
                      <Select.Option value={SUPERADMIN}>Superadmin</Select.Option>
                      <Select.Option value={ADMIN_PROJECT}>Admin Proyek</Select.Option>
                    </Select>
                    <ErrorMessage component="div" name="role" className="gx-text-danger gx-text-sm" />
                  </Item>
                  {formik.values.role === ADMIN_PROJECT ? (
                    <Item name="Proyek" required>
                      <ProjectSelect />
                      <ErrorMessage component="div" name="project" className="gx-text-danger gx-text-sm" />
                    </Item>
                  ) : null}
                  <div className="m-t-15">
                    <Row>
                      <Col span={6}></Col>
                      <Col span={18}>
                        <Button type="primary" htmlType="submit" className="gx-mb-0" loading={formik.isSubmitting}>Simpan User</Button>
                        <Link to="/users" className="ant-btn ant-btn-secondary gx-mb-0">
                          Kembali
                        </Link>
                      </Col>
                    </Row>
                  </div>
                </Card>
              </Form>
            )}
          </Formik>
        </Col>
      </Row>
    </Auxiliary>
  );
}

export default Create;